// packages/ui/src/theme/tokens.ts
//
// Brand color tokens shared by every TourTask surface (backoffice + public
// site). The single source of truth for the brand blue; app themes reference
// these rather than re-declaring the hex. Marketing-only accents (navy, leaf
// green, light blue) stay in the public theme — they are not used in the app.
export const BRAND_BLUE = '#1976d2';
export const BRAND_BLUE_DARK = '#115293';
